import React from "react";
import DashboardLayout from "src/components/templates/layouts/DashbordRouteLayout/DashboardLayout";
import { Container, PageNotFoundElement } from "./styles";
import NotFoundElement from "../../../assets/img/404.svg";

const PageNotFound = () => (
  <DashboardLayout>
    <Container>
      <PageNotFoundElement src={NotFoundElement} />
    </Container>
  </DashboardLayout>
);

export default PageNotFound;
